module.exports = __webpack_public_path__ + "img/nlic_gallery0.19b8cbdf.jpg";